// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-left[data-v-bc9b3a28]{border-left:3px solid #f2f4f5}", ""]);
// Exports
module.exports = exports;
